import { Reveal } from "@/components/site/Reveal";

export const PageHero = ({ eyebrow, title, children, testId }) => (
  <section className="relative overflow-hidden">
    <div aria-hidden="true" className="pointer-events-none absolute -right-32 -top-32 h-[420px] w-[420px] rounded-full bg-[#B9A9D8]/25 blur-3xl" />
    <div className="wrap relative pb-12 pt-16 sm:pb-16 sm:pt-24">
      <Reveal>
        {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
        <h1 className="max-w-3xl text-4xl leading-[1.1] text-[#22304A] sm:text-5xl lg:text-6xl" data-testid={testId}>
          {title}
        </h1>
        {children && <div className="mt-6 max-w-2xl text-base leading-relaxed text-[#22304A]/80 md:text-lg">{children}</div>}
      </Reveal>
    </div>
  </section>
);
